import { Button, ButtonProps } from 'antd';
import React from 'react';
import { ReloadOutlined } from '@ant-design/icons';

interface Props extends ButtonProps {}
export default function ReloadBtn(props: Props) {
  return <Button icon={<ReloadOutlined />} type="primary" danger {...props}></Button>;
}
